import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useModalLabels = (dialogMode: string) => {
  const { t } = useTranslation();
  const [dialogTitle, setDialogTitle] = useState<string>('');
  const [buttonLabel, setButtonLabel] = useState<string>('');
  /**
   * モードに併せてタイトルとボタン名を設定
   */
  useEffect(() => {
    if (dialogMode === 'CREATE') {
      setDialogTitle(t('condition.dialog.titleCreate'));
      setButtonLabel(t('dialog.create'));
    } else if (dialogMode === 'UPDATE') {
      setDialogTitle(t('condition.dialog.titleUpdate'));
      setButtonLabel(t('dialog.update'));
    } else if (dialogMode === 'DELETE') {
      setDialogTitle(t('condition.dialog.titleDelete'));
      setButtonLabel(t('dialog.delete'));
    } else {
      setDialogTitle('');
      setButtonLabel('');
    }
  }, [dialogMode]);

  return {
    dialogTitle,
    buttonLabel,
  };
};

export default useModalLabels;
